import { COPYLASTWEEKTS_SUCCESS, COPYLASTWEEKTS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const copyLastWeekTsReducer = (state = initialState, action) => {
    switch (action.type) {
        case COPYLASTWEEKTS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case COPYLASTWEEKTS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default copyLastWeekTsReducer;
